export const projects = [
    {
        title: "RapidE!",
        description: "E-Commerce Site",
        image: "RapidE.png",
        url: "https://rapid-e.herokuapp.com/",
        github: "https://github.com/mollysal/RapidE"
    },
    {
        title: "Note Taker",
        description: "Note Taker with Express.js",
        image: "NoteTaker.png",
        url: "https://mollysalnotetaker.herokuapp.com/",
        github: "https://github.com/mollysal/Note-Taker"
    },
    {
        title: "Space & Weather Tracker",
        description: "Check for local space launches & the weather nearby.",
        image: "Space&Weather.png",
        url: "https://mollysal.github.io/Space-Weather/",
        github: "https://github.com/mollysal/Space-Weather"
    },
    {
        title: "Coding Quiz",
        description: "Take the quiz to check your knowledge.",
        image: "CodingQuiz.png",
        url: "https://mollysal.github.io/Web-API-Coding-Quiz/",
        github: "https://github.com/mollysal/Web-API-Coding-Quiz"
    },
    {
        title: "J.A.T.E. - PWA Text Editor",
        description: "Text Editor that can run offline",
        image: "JATE_Installed.png",
        url: "https://jate-ms.herokuapp.com/",
        github: "https://github.com/mollysal/PWA-Text-Editor"
    },
    {
        title: "Coming Soon Project 3",
        description: "Final Project",
        image: "BalloonStock.jpg",
        url: "https://github.com/mollysal/",
        github: "https://github.com/mollysal/"
    }
]